import React, { useRef, useEffect } from "react";

export default function RangeSlider(props) {
  const { 
    disabled = false, 
    min = 20, 
    max = 70, 
    value = min, 
    onChange, 
    onBlur 
  } = props;
  
  const rangeRef = useRef(null);
  
  useEffect(() => {
    // Fix for Firefox to ensure the thumb is visible
    if (rangeRef.current) {
      const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
      if (isFirefox) {
        rangeRef.current.style.zIndex = '10';
      }
    }
  }, []);
  
  return (
    <div className="rangeSlider">
      <input
        ref={rangeRef}
        disabled={disabled}
        type="range"
        min={min}
        max={max}
        step={1}
        value={value || min}
        onChange={onChange}
        className="rangeSlider__input"
        onBlur={onBlur}
        style={{
          WebkitAppearance: 'none',
          MozAppearance: 'none',
          appearance: 'none',
          zIndex: 10
        }}
      />
      <span></span>
    </div>
  );
}
